import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'eventName',
    standalone: false
})
export class EventNamePipe implements PipeTransform {

    transform(eventName: string): string {
        if (eventName) {
            eventName = eventName.replace(`Boys' `, `B-`);
            eventName = eventName.replace(`Girls' `, `G-`);
            eventName = eventName.replace(` & under`, `U`);
            eventName = eventName.replace(`singles`, `S`);
            eventName = eventName.replace(`doubles`, `D`);

            return eventName;
        } else {
            return '';
        }
    }
}
